import type {Criterion, CriterionField, Matcher} from '../criteria.types';
import TextCriterion from './text.criterion';

export default class EqCriterion implements Criterion {
    public value: any;

    constructor(public field: CriterionField, private matcher?: { value: any; }) {
        this.value = matcher ? matcher.value : '';
    }

    public clear() {
        this.value = '';
    }

    public isEmpty() {
        return !this.value || this.value.length === 0;
    }

    public toMatcher(): Matcher {
        // When the value is typed as an object with extension and row properties, it is most likely a TextCriterion
        if (typeof this.value === 'object' && 'extension' in this.value && 'row' in this.value) {
            const textCriterion = new TextCriterion(this.field, this.matcher);
            return textCriterion.toMatcher();
        }

        return {
            eq: {
                value: this.value
            }
        };
    }
}
